import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { UserGroup } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserGroupForm from '@/components/user-groups/UserGroupForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditUserGroup',
  props: {
    userGroup: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        id: props.userGroup.id,
        name: props.userGroup.name,
        user_ids: props.userGroup.users.map((group) => group.id),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.user-groups.update'),
    "query-key": [_unref(QueryKey).USER_GROUPS],
    title: "user-groups.user_groups_edit",
    "success-message": "user-groups.updated",
    "error-message": "user-groups.update.error"
  }, {
    default: _withCtx(() => [
      _createVNode(UserGroupForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})